import React, {useContext} from 'react';
import PropTypes from 'prop-types';
// components
import CourseModule from './../../components/CourseModule/CourseModule';
import { ModuleContext, CourseContext, CommonContext } from './../../contexts/constant/ActionTypes';

const CourseModulePage = ({history, match}) => {
    const moduleContext = useContext(ModuleContext);
    const courseContext = useContext(CourseContext);
    const commonContext = useContext(CommonContext);
    return (
        <CourseModule 
            history={history} 
            match={match}
            moduleContext={moduleContext}
            courseContext={courseContext}
            commonContext={commonContext}
        />
    );
}

CourseModulePage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

CourseModulePage.defaultProps = {
    history: {},
    match: {}
};

export default CourseModulePage;



// WEBPACK FOOTER //
// ./containers/CourseModulePage/CourseModulePage.js